import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

const CustomLoader = ({ isErrorText }) => (<Dimmer active>
    <Loader size='massive'>Loading
    </Loader>
</Dimmer>)
export default CustomLoader;
